import React from 'react'
import { CardCP } from 'submodules/nerit-framework-ui/common/components/card/CardCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { QAQCItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCItemResponseDTO'
import { QAQCApprovalDonutChartCP } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCApprovalDonutChartCP'
import { ISummaryRowTP } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCDashboardUtils'
import { QAQCSummaryTableCP } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCSummaryTableCP'

interface ICPProps {
	dto: QAQCItemResponseDTO
}

/**
 * Dashboard de Balanço Iônico: tabela de totais e gráfico donut de amostras aprovadas.
 */
export function DrawerQAQCIonicBalanceCP(props: ICPProps): JSX.Element {

	const totalApproved = props.dto.totalApprovedSamples ?? 0
	const totalRejected = props.dto.totalRejectedSamples ?? 0
	const totalSamples = totalApproved + totalRejected

	const tableData: ISummaryRowTP[] = [
		{ key: 'total', label: 'Total de amostras avaliadas', value: totalSamples },
		{ key: 'approved', label: 'Total de amostras aprovadas', value: totalApproved },
		{ key: 'rejected', label: 'Total de amostras reprovadas', value: totalRejected },
	]

	return (
		<RowCP>
			<ColumnCP md={12}>
				<CardCP
					title={'Quantidade de amostras avaliadas no Balanço Iônico'}
					bordered={true}
					innerSpacing={'none'}
				>
					<QAQCSummaryTableCP data={tableData} />
				</CardCP>
			</ColumnCP>
			<ColumnCP md={12}>
				<QAQCApprovalDonutChartCP
					cardTitle={'Porcentagem Amostras Aprovadas'}
					approved={totalApproved}
					rejected={totalRejected}
				/>
			</ColumnCP>
		</RowCP>
	)
}
